/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { HubSpotLinkDestroyPathParams, HubSpotLinkDestroyResponse } from '../types/HubSpotLinkDestroy'

/**
 * DELETE /:organisation/hubspot
 * @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::destroy
 */
export async function hubSpotLinkDestroy(
	organisation: HubSpotLinkDestroyPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<HubSpotLinkDestroyResponse>> {
	return axiosInstance.delete(`/${organisation}/hubspot`, config)
}
